import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function Hero() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  const go = useCallback(
    (next: number) => setActive((next + total) % total),
    [total],
  );

  useEffect(() => {
    const timer = window.setInterval(() => setActive((i) => (i + 1) % total), 6000);
    return () => window.clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden bg-primary-950">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === active ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 继母的诱惑 ${slide.label}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/55 to-primary-950/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/40" />
        </div>
      ))}

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-content mx-auto">
            <div key={active} className="max-w-2xl jnz-fade-up">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-accent-500/10 px-3.5 py-1.5 text-xs md:text-sm text-accent-300">
                <i className="ri-play-circle-line text-base" />
                {heroSlides[active].label}
              </span>
              <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                {heroSlides[active].title}
              </h1>
              <p className="mt-5 text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl">
                {heroSlides[active].description}
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <Link
                  to={heroSlides[active].link}
                  className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 cursor-pointer transition-colors hover:bg-accent-400 whitespace-nowrap"
                >
                  <i className="ri-book-open-line" />
                  阅读本集剧情
                </Link>
                <Link
                  to="/category/episodes"
                  className="inline-flex items-center gap-2 rounded-md border border-background-100/40 px-6 py-3 text-sm text-background-50 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-200 whitespace-nowrap"
                >
                  浏览全部剧集
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute z-20 bottom-8 left-0 right-0 px-4 md:px-8">
        <div className="max-w-content mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            {heroSlides.map((slide, i) => (
              <button
                key={slide.id}
                type="button"
                aria-label={`切换到 ${slide.title}`}
                onClick={() => go(i)}
                className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                  i === active ? "w-8 bg-accent-400" : "w-4 bg-background-100/40 hover:bg-background-100/70"
                }`}
              />
            ))}
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              type="button"
              aria-label="上一张"
              onClick={() => go(active - 1)}
              className="w-10 h-10 rounded-full border border-background-100/30 text-background-50 flex items-center justify-center cursor-pointer hover:border-accent-300 hover:text-accent-200"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              aria-label="下一张"
              onClick={() => go(active + 1)}
              className="w-10 h-10 rounded-full border border-background-100/30 text-background-50 flex items-center justify-center cursor-pointer hover:border-accent-300 hover:text-accent-200"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}